export const gifts = [
  {
    name: 'Bug Magnet',
    description: 'Able to find bugs in code like they were placed there on purpose.',
    category: 'work',
    superpowers: {
      live: '+500',
      create: '+500',
      love: '+200',
      dream: '+400',
    },
  },

  {
    name: 'Console.log Guru',
    description: 'Uses console.log like a crystal ball to find any issue.',
    category: 'work',
    superpowers: {
      live: '+500',
      create: '+500',
      love: '+200',
      dream: '+400',
    },
  },

  {
    name: 'Shortcut Cheater',
    description: 'Knows every keyboard shortcut like they were born with them.',
    category: 'work',
    superpowers: {
      live: '+500',
      create: '+500',
      love: '+400',
      dream: '+200',
    },
  },

  {
    name: 'Merge Master',
    description: 'Merges branches in Git without conflicts, like a wizard during an exam.',
    category: 'work',
    superpowers: {
      live: '+200',
      create: '+500',
      love: '+200',
      dream: '+300',
    },
  },

  {
    name: 'Async Tamer',
    description: 'Handles asynchronous code and promises like well-trained pets.',
    category: 'work',
    superpowers: {
      live: '+100',
      create: '+400',
      love: '+200',
      dream: '+300',
    },
  },

  {
    name: 'CSS Tamer',
    description: 'Can make Flexbox and Grid work together like they were always best friends.',
    category: 'work',
    superpowers: {
      live: '+200',
      create: '+500',
      love: '+200',
      dream: '+300',
    },
  },

  {
    name: 'Time Hacker',
    description: 'Writes code at the last moment but always meets the deadline.',
    category: 'work',
    superpowers: {
      live: '+500',
      create: '+500',
      love: '+500',
      dream: '+200',
    },
  },

  {
    name: 'Layout Master',
    description: "Creates perfect layouts on the first try, like they can read the designer's mind.",
    category: 'work',
    superpowers: {
      live: '+500',
      create: '+300',
      love: '+200',
      dream: '+200',
    },
  },

  {
    name: 'Documentation Whisperer',
    description: 'Understands cryptic documentation as if they wrote it themselves.',
    category: 'work',
    superpowers: {
      live: '+500',
      create: '+500',
      love: '+200',
      dream: '+100',
    },
  },

  {
    name: 'Feedback Master',
    description: 'Accepts client revisions with the Zen calm of Buddha.',
    category: 'work',
    superpowers: {
      live: '+300',
      create: '+500',
      love: '+300',
      dream: '+400',
    },
  },

  {
    name: 'Code Minimalist',
    description: 'Writes code so concise that one line does more than a whole file.',
    category: 'work',
    superpowers: {
      live: '+500',
      create: '+500',
      love: '+500',
      dream: '+200',
    },
  },

  {
    name: 'Pixel-Perfect Magician',
    description: 'Aligns elements to the last pixel, even when the design looks abstract.',
    category: 'work',
    superpowers: {
      live: '+500',
      create: '+500',
      love: '+400',
      dream: '+400',
    },
  },

  {
    name: 'Posture Levitation',
    description: 'Can sit for hours, but maintains perfect posture like a ballerina.',
    category: 'health',
    superpowers: {
      live: '+400',
      create: '+500',
      love: '+500',
      dream: '+400',
    },
  },

  {
    name: 'Step Master',
    description: 'Gets 10,000 steps a day even while sitting at the computer.',
    category: 'health',
    superpowers: {
      live: '+400',
      create: '+300',
      love: '+500',
      dream: '+400',
    },
  },

  {
    name: 'Snack Resister',
    description: 'Ignoring desktop snacks like a strict dietician.',
    category: 'health',
    superpowers: {
      live: '+400',
      create: '+100',
      love: '+200',
      dream: '+400',
    },
  },

  {
    name: 'Hydration Bot',
    description: 'Drinks the recommended 2 liters of water a day like a health-programmed robot.',
    category: 'health',
    superpowers: {
      live: '+500',
      create: '+300',
      love: '+500',
      dream: '+500',
    },
  },

  {
    name: 'Sleep Overlord',
    description: 'Sleeps 6 hours but feels like they had 10.',
    category: 'health',
    superpowers: {
      live: '+400',
      create: '+500',
      love: '+500',
      dream: '+500',
    },
  },

  {
    name: 'Break Guru',
    description: 'Takes a stretch break every hour without forgetting, no matter how focused.',
    category: 'health',
    superpowers: {
      live: '+300',
      create: '+300',
      love: '+300',
      dream: '+400',
    },
  },

  {
    name: 'Eye Protector',
    description: 'Can work all day at the monitor without feeling like their eyes are on fire.',
    category: 'health',
    superpowers: {
      live: '+100',
      create: '+300',
      love: '+500',
      dream: '+400',
    },
  },

  {
    name: 'Stress Dodger',
    description: 'Masters meditation right at the keyboard.',
    category: 'health',
    superpowers: {
      live: '+100',
      create: '+400',
      love: '+200',
      dream: '+400',
    },
  },

  {
    name: 'Yoga Coder',
    description: 'Easily switches from coding to yoga and back.',
    category: 'health',
    superpowers: {
      live: '+400',
      create: '+400',
      love: '+400',
      dream: '+400',
    },
  },

  {
    name: 'Healthy Snacker',
    description: 'Always picks fruit, even when chocolate is within arm’s reach.',
    category: 'health',
    superpowers: {
      live: '+400',
      create: '+300',
      love: '+200',
      dream: '+400',
    },
  },

  {
    name: 'Chair Exerciser',
    description: 'Manages to work out without leaving the chair.',
    category: 'health',
    superpowers: {
      live: '+500',
      create: '+500',
      love: '+500',
      dream: '+400',
    },
  },

  {
    name: 'Caffeine Filter',
    description: 'Drinks coffee at night and still falls asleep with no problem.',
    category: 'health',
    superpowers: {
      live: '+400',
      create: '+300',
      love: '+500',
      dream: '+200',
    },
  },

  {
    name: 'Joy Charger',
    description: 'Finds joy in the little things—even in a build that finishes unexpectedly fast.',
    category: 'harmony',
    superpowers: {
      live: '+200',
      create: '+200',
      love: '+500',
      dream: '+500',
    },
  },

  {
    name: 'Error Laugher',
    description: 'Laughs at code errors like they’re jokes instead of getting angry.',
    category: 'harmony',
    superpowers: {
      live: '+300',
      create: '+200',
      love: '+500',
      dream: '+500',
    },
  },

  {
    name: 'Bug Acceptance Guru',
    description: 'Accepts bugs as part of the journey to perfection — it’s just another task.',
    category: 'harmony',
    superpowers: {
      live: '+300',
      create: '+200',
      love: '+500',
      dream: '+400',
    },
  },

  {
    name: 'Spontaneous Coding Philosopher',
    description: 'Philosophically accepts any client suggestion after a long refactor.',
    category: 'harmony',
    superpowers: {
      live: '+300',
      create: '+200',
      love: '+500',
      dream: '+400',
    },
  },

  {
    name: 'Deadline Sage',
    description: 'Remains zen even when the deadline is close and the project manager is stressed.',
    category: 'harmony',
    superpowers: {
      live: '+200',
      create: '+200',
      love: '+300',
      dream: '+500',
    },
  },

  {
    name: 'Inspiration Maestro',
    description: 'Finds inspiration on an empty screen as if masterpieces are already there.',
    category: 'harmony',
    superpowers: {
      live: '+300',
      create: '+200',
      love: '+400',
      dream: '+100',
    },
  },

  {
    name: 'Peace Keeper',
    description: 'Maintains inner calm even in moments of intense crisis.',
    category: 'harmony',
    superpowers: {
      live: '+200',
      create: '+200',
      love: '+500',
      dream: '+500',
    },
  },

  {
    name: 'Empathy Guru',
    description: 'Feels the team’s mood and can lift everyone’s spirits.',
    category: 'harmony',
    superpowers: {
      live: '+500',
      create: '+200',
      love: '+500',
      dream: '+500',
    },
  },

  {
    name: 'Laughter Generator',
    description: 'Can lighten any tense situation with a joke that even bugs laugh at.',
    category: 'harmony',
    superpowers: {
      live: '+300',
      create: '+200',
      love: '+200',
      dream: '+500',
    },
  },

  {
    name: 'Pause Master',
    description: 'Knows when to just step back from the keyboard and breathe.',
    category: 'harmony',
    superpowers: {
      live: '+300',
      create: '+200',
      love: '+100',
      dream: '+100',
    },
  },

  {
    name: 'Coder Healer',
    description: 'Can support a colleague in their darkest hour, even if it’s a 500 error.',
    category: 'harmony',
    superpowers: {
      live: '+300',
      create: '+200',
      love: '+500',
      dream: '+500',
    },
  },

  {
    name: 'Music Code Curator',
    description: 'Creates work playlists so good, even deadlines follow the rhythm.',
    category: 'harmony',
    superpowers: {
      live: '+300',
      create: '+200',
      love: '+300',
      dream: '+200',
    },
  },
];
